import saveAs from 'file-saver';
import * as XLSX from 'xlsx';

export interface ColumnWidth {
	wch: number;
}

export interface ExportPayload {
	data: string[][];
	columnWidths: ColumnWidth[];
}

export const exportExcel = (
	data: string[][],
	columnWidths: ColumnWidth[],
	fileName: string,
) => {
	const fileType =
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	const type = 'xlsx';

	const workSheet = XLSX.utils.aoa_to_sheet(data);

	// Set column widths (see https://stackoverflow.com/questions/24395693/how-to-set-cell-width-when-export-xlsx-files-with-js-xlsx)
	workSheet['!cols'] = columnWidths;

	const workBook = {
		Sheets: { data: workSheet, cols: [] },
		SheetNames: ['data'],
	};

	const excelBuffer = XLSX.write(workBook, {
		bookType: type,
		type: 'array',
	});

	const fileData = new Blob([excelBuffer], { type: fileType });

	saveAs(fileData, fileName + '.' + type);
};
